import { createContext } from 'react';
import { IChatsContext } from './types';

const ChatsContext = createContext<IChatsContext>({} as IChatsContext);

export default ChatsContext;
